import { render, staticRenderFns } from "./BodyEditor.vue?vue&type=template&id=6b72ec73&scoped=true"
import script from "./BodyEditor.vue?vue&type=script&lang=js"
export * from "./BodyEditor.vue?vue&type=script&lang=js"
import style0 from "./BodyEditor.vue?vue&type=style&index=0&id=6b72ec73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72ec73",
  null
  
)

export default component.exports